
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iletisim",
      function () {
        return require("private-next-pages/iletisim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iletisim"])
      });
    }
  